import { NavLink } from "react-router-dom";
import { CardLinkProps } from "./card.link.props";

export const CardLink: React.FC<CardLinkProps> = ({ isExternal, to, className, children, ...props }) => isExternal ?
    (<a href={to} className={className}>{children}</a>) :
    (<NavLink to={to} className={className} {...props}>{children}</NavLink>);